import React, { useEffect, useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { IStudentsPage } from "./types";

const StudentsPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [students, setStudents] = useState<IStudentsPage[]>([]);
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const privilege = parseInt(localStorage.getItem("privilege") || "0");
  const canAddStudent = privilege === 1 || privilege === 2;

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch("https://has-backend-c48d669d897f.herokuapp.com/admin/students", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setStudents(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar estudiantes:", error);
        setIsLoading(false);
      });
  }, [refreshTrigger]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage("");
    const token = localStorage.getItem("token");

    try {
      const response = await fetch("https://has-backend-c48d669d897f.herokuapp.com/admin/student/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ name, email, password }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Registration failed");

      setMessage("Registro exitoso");
      setShowPopup(false);
      setRefreshTrigger((prev) => prev + 1);

      setName("");
      setEmail("");
      setPassword("");
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  const filteredStudents = students.filter((student) =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    student.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen w-full px-4 sm:px-8">
      {canAddStudent && (
        <div className="flex flex-col items-start gap-8">
          <h2 className="font-playfair font-bold text-3xl sm:text-4xl mt-12">Acciones</h2>
          <button
            onClick={() => setShowPopup(true)}
            className="bg-[#1c1c2e] text-white font-sourceSans rounded-lg py-2 px-6 sm:w-[23%] w-full"
          >
            + Añadir
          </button>
        </div>
      )}

      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-4">
          <div className="bg-[#d9d9d9] w-full sm:w-2/3 md:w-1/2 lg:w-1/3 p-6 rounded-lg shadow-lg relative">
            <button
              className="absolute top-2 right-4 text-gray-700 text-xl"
              onClick={() => setShowPopup(false)}
            >
              ×
            </button>
            <form onSubmit={handleSubmit} className="flex flex-col gap-2">
              <label className="font-sourceSans">Nombre Completo</label>
              <input
                className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 px-2"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <label className="font-sourceSans">Correo electrónico</label>
              <input
                className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 px-2"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label className="font-sourceSans">Contraseña</label>
              <input
                className="border border-[#8E8E8E] rounded-md bg-[#FAFAFA] shadow-lg py-2 px-2"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                className="bg-[#1c1c2e] text-white rounded-lg py-2 mt-6 font-sourceSans"
                type="submit"
              >
                Añadir estudiante
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="flex flex-col items-start gap-4 mt-12">
        <h2 className="font-playfair font-bold text-3xl sm:text-4xl">Todos los estudiantes</h2>

        <input
          type="text"
          placeholder="Buscar por nombre o correo..."
          className="mb-6 mt-2 px-4 py-2 rounded-md border border-gray-400 w-full sm:w-1/2"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="w-full flex flex-col">
          <div className="hidden sm:flex flex-row justify-between px-12 pb-4">
            <p className="font-bold font-sourceSans">Estudiante</p>
            <p className="font-bold font-sourceSans">Correo</p>
          </div>

          {isLoading ? (
            <p>Cargando estudiantes...</p>
          ) : filteredStudents.length > 0 ? (
            filteredStudents.map((student) => (
              <div
                key={student._id}
                className="flex flex-col sm:flex-row justify-between border-y border-gray-600 py-2 px-4 sm:px-12 text-sm sm:text-base"
              >
                <a
                  onClick={() => navigate(`/admin/students/${student._id}`)}
                  className="text-[#2755ee] font-sourceSans cursor-pointer"
                >
                  {student.name}
                </a>
                <p className="font-sourceSans mt-1 sm:mt-0">{student.email}</p>
              </div>
            ))
          ) : (
            <p>No se encontraron estudiantes.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentsPage;

